import { css } from '@emotion/core';
import { StyledColumnWrap } from './styles';
export default (function (theme) {
  return /*#__PURE__*/css(StyledColumnWrap, "{@media screen and (max-width:68em){text-align:center;}&.el--2{@media screen and (min-width:40em){grid-template-columns:1fr;}@media screen and (min-width:68em){grid-template-columns:1fr 1fr;}}");
});